import { OidcActions, OidcGetters } from '@/store/oidc/oidc.module';
import { computed, defineComponent, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import BackgroundComponent from '@/components/background/Background.vue';

export default defineComponent({
  name: 'WelcomePage',
  components: {
    BackgroundComponent
  },
  setup: () => {
    const router = useRouter();
    const store = useStore();
    const authIsChecked = computed<boolean>(() => store.getters[OidcGetters.AUTHENTICATION_IS_CHECKED]);

    onBeforeMount(() => {
      if (authIsChecked.value) {
        router.push('/');
      }
    });

    const authClick = () => {
      store.dispatch(OidcActions.AUTHENTICATE_OIDC);
    };

    return {
      authClick
    };
  }
});
